module.exports = __webpack_public_path__ + "static/img/ruggedian-main.05058f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ruggedian-main.jpg
// module id = 122
// module chunks = 0